/**
 * Created by evgenijsenkevic on 8/7/25
 */

// eslint-disable-next-line
let LightningRushStartWindow = Prefab.createWindow("lighting_rush", "lightning_rush_start_window_prefab_json", {
    theme: () => bundles.lighting_rush.jsons.theme_json
});
